<template>
    <div class="text-center">
      <v-dialog v-model="dialog" max-width="500" persistent>
        <v-card>
          <v-card-title class="text-h5 blue darken-3 white--text">
            Completar los datos
          </v-card-title>
  
          <v-card-text> 
            <v-text-field label="Fecha de otorgamiento:" v-model="fecha_otorgamiento"  type="date" prefix="el:" hide-details />
            <v-text-field label="Turno:" v-model="turno" hide-details />
            <v-text-field label="Porcentaje beca:" v-model="porcentaje_beca" hide-details />
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" outlined @click="enviar()"> Aceptar </v-btn>
            <v-btn color="red" outlined @click="cerrar()"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>
  
<script>

export default {
    data() {
        return { 
            dialog: false,
            turno: '', 
            porcentaje_beca: '', 
            fecha_otorgamiento: {}, 
            resolvePromise: null,
        };
    },
    methods: {
        async openmodal(p) { 
          this.proy = p
          this.dialog = true; 
          this.hoy()
          return new Promise((resolve) => {
              this.resolvePromise = resolve;
          });
        },
        hoy(){
          const fechaActual = new Date(); 
          const año = fechaActual.getFullYear();
          const mes = String(fechaActual.getMonth() + 1).padStart(2, '0'); 
          const dia = String(fechaActual.getDate()).padStart(2, '0'); 
          const fechaFormateada = `${año}-${mes}-${dia}`;
          this.fecha_otorgamiento = fechaFormateada;
        }, 

        cerrar(){
          this.resolvePromise(false);
          this.dialog = false;
        },
        enviar(){ 
            if(!this.fecha_otorgamiento) return 
            if(!this.turno) return 
            if(!this.porcentaje_beca) return 
            const fs = this.fecha_otorgamiento.split('-')
            const input = {
                fecha_otorgamiento: `${fs[2]} / ${fs[1]} / ${fs[0]}`,
                turno: this.turno,
                porcentaje_beca: this.porcentaje_beca
            }
            this.resolvePromise(input);
            this.dialog = false;
        }
    }
};
</script>
  